@if (!operation) {
  <div class="flex-horizontal flex-center padding-16 width-100pc height-100pc">
    <oui-loading class="flex-horizontal flex-center padding-16 width-100pc justify-center"></oui-loading>
  </div>
}
@if (operation) {
  <div class="page-body flex-horizontal background-white height-100pc">
    <app-operations-panel-info [operation]="operation" [isConsultant]="true" (onBackArrowClicked)="onBackArrowClicked()">
    </app-operations-panel-info>
    <div class="page-content padding-72 gap-32 flex-vertical width-100pc background-background">
      <div class="flex-horizontal width-100pc gap-16 flex-center">
        <h6>Documents & justificatifs</h6>
        @if ($any(operation).proxeemaOperationUrl) {
          <a [href]="$any(operation).proxeemaOperationUrl" target="_blank" rel="noopener noreferrer">Ouvrir l'opération Proxeema</a>
        }
        <div class="flex-1"></div>
        @if (!hideStatusChangeButton) {
          @if (!isEditableMode && !isOperationEndable) {
            <oui-button type="text" iconPrefix="undo" [disabled]="!isDeclarationCancelable"
              (click)="onCancelDeclaration()">
              Récupérer l'opération
            </oui-button>
            @if (!isDeclarationCancelable) {
              <oui-infos-bulle bulleTitle="Traitement en cours">Vous ne pouvez pas annuler
                la
              déclaration car l’opération est en cours de traitement.</oui-infos-bulle>
            }
          }
          @if (isOperationEndable) {
            <oui-button type="outlined" (click)="onEndOperation()">Marquer comme terminé</oui-button>
          }
        }
        @if (isEditableMode) {
          <oui-menu class="demo-component" [menuItems]="fileMenu" horizontalPosition="left"
            verticalPosition="bottom">
            @if (!isFilesLoading) {
              <oui-button type="outlined" iconPrefix="add_circle_outline">
                Ajouter des documents
              </oui-button>
            }
            @if (isFilesLoading) {
              <oui-loading size="small"></oui-loading>
            }
          </oui-menu>
        }
        @if (isEditableMode) {
          <oui-button (click)="fireConsultantFixesNCTransitionAndGo()"
          [disabled]="!isSendUpdatePossible">Envoyer la mise à jour</oui-button>
        }
      </div>
      @if (isSendUpdatePossible && isUserHabilited) {
        <oui-banner
          title="Les retours traités n'ont pas été envoyés à Stellium Placement. Cliquez sur “Envoyer la mise à jour” ci-dessus."
        declination="error" [showCloseButton]="false"></oui-banner>
      }
      @if (isEditableMode && !isUserHabilited) {
        <oui-banner
          title="Vous n'avez aucune habilitation active pour ce produit."
        declination="error" [showCloseButton]="false"></oui-banner>
      }
      @if (operation.commentaireGestionnaire) {
        <oui-banner type="complex" title="Commentaire de Stellium Placement"
          [description]="operation.commentaireGestionnaire" declination="alert" class="no-shrink"
        [showCloseButton]="false"></oui-banner>
      }
      @if (!isEditableMode) {
        <div class="flex-vertical">
          <lib-operation-files-list class="files-list" audience="consultant" [checkbox]="false"
            [files]="responseService.fichiersOperations" [displayStatus]="false"
          (fileClicked)="onfileViewClick($event)"></lib-operation-files-list>
        </div>
      }
      @if (isEditableMode) {
        <app-files-list-status [files]="responseService.fichiersOperations"
          (fileClicked)="onEditableFileClick($event)" [checkbox]="false">
        </app-files-list-status>
      }
    </div>
  </div>
}

<ng-template #documentViewerPortalContent>
  <app-response-nc-document-viewer [selectedFile]="selectedFile" [operation]="operation"
  (close)="closeDocumentViewer($event)"></app-response-nc-document-viewer>
</ng-template>
